import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-tooltip" }

import { VIconSvg } from "@/components";

import { TranslateResult } from "vue-i18n";

export interface Props {
  error?: string | TranslateResult;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VErrorTooltip',
  props: {
    error: { default: "" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VIconSvg), {
      name: "Danger",
      color: "fc-error",
      class: "error-icon",
      size: "xs"
    }),
    _createTextVNode(" " + _toDisplayString(props.error), 1)
  ]))
}
}

})